// Aura color map for Human Design types
export const AURA_COLORS = {
  Generator: "#FF5A36",
  "Manifesting Generator": "#FF5A36",
  Projector: "#2ED199",
  Manifestor: "#DC143C",
  Reflector: "#E0E7FF",
};

export const auraClass = (type) =>
  ({
    Generator: "aura-glow-generator",
    "Manifesting Generator": "aura-glow-manifesting_generator",
    Projector: "aura-glow-projector",
    Manifestor: "aura-glow-manifestor",
    Reflector: "aura-glow-reflector",
  }[type] || "");
